export default {
  username: {
    required: true,
    minLength: 0,
    validateOnBlur: true,
  },
};
